/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { FunctionComponent, useEffect } from 'react';

import { AppUtils } from '../../../../../core/AppUtils';
import { CursorManager } from '../../../../../core/navigation';
import {
    RootState,
    useTivoDispatch,
    useTivoSelector,
} from '../../../../../core/tivo/tivo-redux-wrapper';
import { disableGhostModeToDoList } from '../../../../../store/settings/todolist/todolist.reducers';
import { Highlight } from '../../../../Highlight';

interface ToDoListHighlightProps {
    id?: string;
    cellType?: string;
}

export const ToDoListHighlight: FunctionComponent<ToDoListHighlightProps> = ({
    id,
    cellType,
}): JSX.Element => {
    const verticalPosition = useTivoSelector((state: RootState) => state.todoList.verticalPosition);
    const ghostMode = useTivoSelector((state: RootState) => state.todoList.ghostMode);

    const { isOverlayDialogActive: isAnyGuideOverlayVisible } = useTivoSelector(
        (state: RootState) => state.overlayDialog,
    );

    const { isSpinnerActive } = useTivoSelector((state: RootState) => state.spinner);

    const dispatch = useTivoDispatch();
    const isCursorAppeared = CursorManager.isCursorAppeared();

    useEffect(() => {
        if (!isCursorAppeared && ghostMode) {
            dispatch(disableGhostModeToDoList());
        }
    }, [isCursorAppeared, ghostMode, dispatch]);

    const currentId = AppUtils.createHighlightId(0, verticalPosition);
    const isActive = id === currentId;
    const isGhostHighlightActive = ghostMode && isActive;
    const isHighlightVisible = !(isAnyGuideOverlayVisible || isSpinnerActive);

    return (
        <Highlight
            cellType={cellType}
            isActive={isActive}
            isGhostHighlightActive={isGhostHighlightActive}
            isHighlightVisible={isHighlightVisible || ghostMode}
            isPastGuideMode={false}
        />
    );
};
